import React from "react";
// import "./Decision.css";

const Decision = ({
  imgSeleccion,
  yaHizoOtroOjo,
  onContinuar,
  onFinalizar,
  className = "",
}) => {
  return (
    <div className={`test-container ${className}`}>
      <h1 className="test-instrucciones">Continuar</h1>
      <img
        src={imgSeleccion}
        alt="seleccion ojo"
        className="img-seleccion-ojo"
      />
      <div className="instruccion-card">
        <p>¿Desear hacer el test con el ojo opuesto al seleccionado?</p>
        <p>Si es así, cubre el ojo opuesto para iniciar el test</p>
      </div>

      <div className="botones-ojo">
        {!yaHizoOtroOjo && (
          <button onClick={onContinuar} className="btn-ojo">
            Continuar
          </button>
        )}
        <button onClick={onFinalizar} className="btn-ojo">
          Finalizar
        </button>
      </div>
    </div>
  );
};

export default Decision;